<template>
  <div id="v-onboarding-frame">
    <!-- Header -->
    <header class="ob-header">
      <div class="ob-header-heading" v-bind:class="titleNotVisible">
        <h5>Account Setup</h5>
        <h2>{{title}}</h2>
      </div>
      <div class="ob-header-profile">
        <div class="ob-header-profile-head">
          <b style="font-weight: 600;">{{$store.getters.user.fullname}}</b><br>
          <span style="font-size: 0.8em; color: #929292;">@{{$store.getters.user.handle}}</span>
        </div>
        <img class="ob-header-profile-img" v-bind:src="$store.getters.user.userProfileImg"/>
      </div>
    </header>
    <!-- View -->

    <div id="v-collective-view">
      <transition name="slide-side-fade" mode="out-in">
        <div id="v-collective-members" v-if="step == 1" key="step1">
          <div style="text-align: left; line-height: 1.4; max-width: 240px; margin-right: 40px;">
            <div class="medallion"></div>
            <b>Welcome to Prism!</b>
            <p>We’re excited to have you join us. Soon, you will be up and running with an online hub to showcase your photography.</p>
            <p>To begin, you must first start a <b>Collective</b> to store and host your images in.</p>
            <p>What type of collective will you be creating?</p>
          </div>
          <div class="v-collective-option-jumbo" @click="collectiveType = 'personal'" v-bind:class="{selected: collectiveType == 'personal'}">
            <i class="material-icons">person</i><br>
            <b>I want to create a</b>
            <h2 class="h-thin">Personal Collective</h2>
            <i style="font-size: 12px; display: inline-block; width: 150px; margin: 10px; margin-bottom: 16px">For showcasing your own photography</i><br>
            <div class="text-divvy" v-if="collectiveType == 'personal'">SELECTED</div>
          </div>
          <div class="v-collective-option-jumbo v-collective-option-dark" @click="collectiveType = 'team'" v-bind:class="{selected: collectiveType == 'team'}">
            <i class="material-icons">group</i><br>
            <b>I want to create a</b>
            <h2 class="h-thin">Team Collective</h2>
            <i style="font-size: 12px; display: inline-block; width: 150px; margin: 10px; margin-bottom: 16px">For showcasing your team's photography</i><br>
            <div class="text-divvy" v-if="collectiveType == 'team'">SELECTED</div>
          </div>
        </div>
        <div id="v-collective-cform" v-if="step == 2" key="step2">
          <div style="text-align: left">
            <b style="display: block;">Collective Name (*)</b>
            <div class="ipt-container no-left" style="display: block; margin-left: 0;">
              <input type="text" v-model="collectiveName"/>
            </div>
            <br>
            <b style="display: block;">Site Handle (*)</b>
            <div>
              <span style="display: inline-block; margin: 8px 0; font-size: 1.4em; font-weight: 300;">prism.encadyma.com/@/<b v-if="!forceUsingHandles && collectiveType == 'personal'">{{$store.getters.user.handle}}</b></span>
              <div class="ipt-container no-left" style="display: inline-block; width: 200px; vertical-align: top;" v-if="collectiveType == 'team' || forceUsingHandles">
                <input type="text" v-model="definedCollectiveHandle" style="margin: 0;"/>
              </div>
            </div>
            <i style="font-size: 12px; color: #444;" v-if="!forceUsingHandles && collectiveType == 'personal'">
              Personal collectives use your account's handle as the default site handle.<br>
              If you prefer to use a different site handle, <a style="vertical-align: text-top" @click="forceUsingHandles = true">click here.</a>
            </i>
            <i style="font-size: 12px; color: #444;" v-if="forceUsingHandles && collectiveType == 'personal'">
              If you prefer to go back and use your account's handle, <a style="vertical-align: text-top" @click="forceUsingHandles = false">click here.</a>
            </i>
            <i style="font-size: 12px; color: #ff2222;" v-if="hasEmptyCollectiveError">
              Please enter in a collective handle.
            </i>
            <i style="font-size: 12px; color: #ff2222;" v-if="hasCollectiveError">
              It seems like this name has already been taken. Please use a different handle.
            </i>
          </div>
          <img src="../../assets/MockOnboardingCollectiveSample.png" style="height: 460px"/>
        </div>
        <div id="v-collective-inviteform" v-if="step == 3" key="step3">
          <div>
            <img src="../../assets/MockOnboardingInviteHeader.png" style="margin-bottom: 40px;"/>
            <img src="../../assets/MockOnboardingInviteMembers.png" style="margin-bottom: 40px;"/>
          </div>
          <div style="text-align: left; margin-left: 100px; margin-right: 20px; max-width: 240px; line-height: 1.4;">
            <div class="medallion"></div>
            <b>Setting up your team is easy.</b>
            <p>Whether a member is a photographer, designer, or manager, Prism has a flexible set of user roles for your team.</p>
            <p>To add a member, you may either send an <b>invitation</b> to an email address or create a <b>shareable invite link</b> to share among a group.</p>
            <p style="font-size: 14px; color: #807D7D;">Invitations will be live updated. <a><b style="font-weight: 600;">Click here to manually refresh.</b></a></p>
          </div>
          <div style="position: absolute; top: 60px; left: calc(50% - 200px); filter: none; width: 400px; opacity: 1;">
            <h1>Inviting members is not enabled yet</h1>
            <p>This feature will be enabled in a later release of Prism. For now, you may invite members in the admin panel of your Collective.</p>
            <p>Click on 'Finish' to complete the setup.</p>
          </div>
        </div>
        <div id="v-collective-loading" v-if="step == 4" key="step4">
          <div class="c-loading" style="margin-top: 40px; margin-bottom: 40px;"></div>
          <span style="color: #555;">Finishing up..</span>
        </div>
        <div id="v-collective-fform" v-if="step == 5" key="step5">
          <img src="../../assets/OnboardingFinal.png" style="position: absolute; left:0; top:0; height: 100%;"/>
          <div style="position: absolute; height: 450px; right: 45vh;">
            <div style="text-align: left; line-height: 1.4; max-width: 240px;">
              <div class="medallion"></div>
              <b>Prism is now setup.</b>
              <p>Your account is now ready for use and has full access to Prism’s services.</p>
              <p>Take a deep breath. Get excited. There’s a lot that Prism has to offer and a great deal more to explore, starting from the Dashboard.</p>
              <p>Thank you for choosing Prism. We can’t wait to see how you color your story.</p>
              <p style="font-weight: 300;">- Prism Group</p>
            </div>
            <router-link to="dashboard" style="display: inline-block; margin-top: 40px;">Go to Dashboard</router-link>
          </div>
        </div>
      </transition>
    </div>

    <!-- Footer Buttons -->
    <div class="ob-buttons" v-bind:class="barNotVisible">
      <button @click="previousStep()" v-bind:class="backNotVisible">{{btnBack}}</button>
      <button @click="nextStep()" v-bind:class="continueNotVisible">{{btnContinue}}</button>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      step: 1,
      collectiveType: '',
      definedCollectiveHandle: '',
      collectiveName: '',
      forceUsingHandles: false,
      hasCollectiveError: false,
      hasEmptyCollectiveError: false,
      isCheckingUniqueHandle: false
    }
  },
  methods: {
    previousStep: function () {
      this.step--
    },
    nextStep: function () {
      if (!this.validateStep(this.step)) return false

      this.hasEmptyCollectiveError = false
      this.hasCollectiveError = false

      // Check for handle uniqueness
      if ((this.step === 2) && this.collectiveHandle) {
        this.isCheckingUniqueHandle = true
        this.confirmUniqueHandle().then((isUnique) => {
          if (isUnique) {
            this.hasCollectiveError = false
            this.step++
          } else {
            this.hasCollectiveError = true
          }
          this.isCheckingUniqueHandle = false
        })
        return true
      }

      if ((this.step === 2) && !this.collectiveHandle) {
        this.hasEmptyCollectiveError = true
        return false
      }

      this.step++
      if (this.step === 4) this.submitSetup()
    },
    validateStep: function (stepNumber) {
      // Validates the setup at a specific step number
      if (stepNumber === 1 && !this.collectiveType) return false
      if (stepNumber === 2 && !this.collectiveHandle) return false
      if (stepNumber === 2 && !this.collectiveName) return false
      return true
    },
    submitSetup: function () {
      // Simulate loading delay
      setTimeout(() => {
        this.confirmUniqueHandle().then((isUnique) => {
          if (isUnique) {
            let usersObject = {}
            usersObject[this.$store.getters.user.uid] = 1
            this.$firestore.collection('collectives').doc('@' + this.collectiveHandle)
              .set({
                createdAt: new Date(),
                fullname: this.collectiveName,
                handle: this.collectiveHandle,
                headerImageRef: '',
                images: [],
                licensing: {
                  commissions: false,
                  distributions: {
                    free: false,
                    requiresCrediting: true
                  }
                },
                members: usersObject,
                profileImageRef: '',
                services: null,
                followers: {}
              }).then(() => {
                this.step = 5
              })
          } else {
            this.hasCollectiveError = true
            this.step = 2
          }
        })
      }, 3000)
    },
    confirmUniqueHandle: function () {
      return new Promise((resolve, reject) => {
        this.$firestore.collection('collectives').doc('@' + this.collectiveHandle)
          .get().then((doc) => {
            if (doc.exists) {
              resolve(false)
            } else {
              resolve(true)
            }
          })
      })
    }
  },
  computed: {
    title: function () {
      switch (this.step) {
        case 1: return 'Welcome to Prism'
        case 2: return 'Collective Setup'
        case 3: return 'Invite Members'
        case 4: return 'Finishing up..'
        case 5: return 'Finished!'
        default: return 'Welcome to Prism'
      }
    },
    collectiveHandle: function () {
      if (this.collectiveType === 'personal' && !this.forceUsingHandles) return this.$store.getters.user.handle
      return this.definedCollectiveHandle
    },
    backNotVisible: function () {
      return {
        notvisible: (this.step === 1)
      }
    },
    continueNotVisible: function () {
      return {
        notvisible: !this.validateStep(this.step) || this.hasEmptyCollectiveError || this.isCheckingUniqueHandle
      }
    },
    titleNotVisible: function () {
      return {
        notvisible: (this.step === 5)
      }
    },
    barNotVisible: function () {
      return {
        notvisible: (this.step === 4 || this.step === 5)
      }
    },
    btnContinue: function () {
      if (this.step === 3) return 'Finish'
      return 'Continue'
    },
    btnBack: function () {
      return 'Back'
    }
  }
}
</script>
<style lang="scss">
  .ob-header {
    padding: 40px 20px;
    padding-bottom: 60px;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ob-header-heading {
    text-align: left;
    h2 {
      font-size: 2em;
      margin: 5px 0;
      font-weight: 600;
    }
    h5 {
      font-size: 1em;
      font-weight: 400;
      color: #666;
      margin: 5px 0;
    }
  }
  .ob-header-profile {
    text-align: right;
  }
  .ob-buttons {
    display: flex;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 40px;
    justify-content: space-between;
  }
  #v-collective-cform {
    display: flex;
    max-width: 1050px;
    padding-left: 100px;
    margin: 0 auto;
    justify-content: space-between;
    align-items: flex-start;
  }
  #v-collective-inviteform {
    display: flex;
    justify-content: center;
    position: relative;
    & > div {
      filter: blur(10px);
      opacity: 0.6;
    }
  }
  #v-collective-inviteform img {
    display: block;
  }
  .medallion {
    border-radius: 8px;
    height: 6px;
    width: 40px;
    background-color: #D8D8D8;
    margin: 16px 0;
  }

  #v-collective-members {
    display: flex;
    max-width: 960px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
  .v-collective-option-jumbo {
    width: 300px;
    height: 360px;
    margin: 0 10px;
    padding: 20px 10px;
    box-sizing: border-box;
    background-color: #EEEEEE;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    opacity: 0.6;

    h2 {
      font-size: 1.4em;
      margin: 8px 0;
    }
    b {
      font-weight: 500;
      font-size: 14px;
    }
    .material-icons {
      font-size: 48px;
      margin-top: 10px;
      margin-bottom: 16px;
    }

    &:after {
      background-color: #CBCBCB;
      border-radius: 3px;
      width: 180px;
      height: 6px;
      position: absolute;
      bottom: 14px;
      content: '';
      left: 60px;
      transition: 150ms ease;
    }

    &:hover:after {
      width: 200px;
      left: 50px;
      transition: 150ms ease;
      bottom: 18px;
    }

    &:active:after {
      background-color: #AFAFAF;
      width: 170px;
      left: 65px;
      transition: 50ms ease;
      bottom: 12px;
    }

    &.selected {
      box-shadow: 0 2px 24px rgba(0, 0, 0, 0.2);
      opacity: 1;
      transition: 150ms ease;
    }

    &.v-collective-option-dark {
      background-color: #2F2F2F;
      color: #EDEDED;

      h2 {
        color: #EDEDED;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Onboarding/OnboardingFrame.vue